import rotatePoint from './rotatePoint'
import pointInPolygon from './pointInPolygon'

const findBlcokInstanceByCoordinates = (
  mouse,
  { dx, dy, blockInstances, xScale, yScale, imageScale, transform: t }
) => {
  const mx = mouse[0] - dx * t.k
  const my = mouse[1] - dy * t.k

  if (blockInstances) {
    for (let i = 0; i < blockInstances.ids.length; i++) {
      const bi = blockInstances.byId[blockInstances.ids[i]]
      const x = xScale(bi.map.x)
      const y = yScale(bi.map.y)
      const w = t.k * imageScale(bi.map.w)
      const h = t.k * imageScale(bi.map.h)
      const polygon = [
        rotatePoint([-w / 2, -h / 2], bi.map.rotation),
        rotatePoint([w / 2, -h / 2], bi.map.rotation),
        rotatePoint([w / 2, h / 2], bi.map.rotation),
        rotatePoint([-w / 2, h / 2], bi.map.rotation),
      ].map((p) => [x + p[0], y + p[1]])

      if (pointInPolygon([mx, my], polygon)) return bi
    }
  }

  return null
}

export default findBlcokInstanceByCoordinates
